// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__nUjaF","boxTitle":"Qualiphy_boxTitle__37AfR","box":"Qualiphy_box__2OROZ","toggleWrap":"Qualiphy_toggleWrap__1A5xH"};